window.cookieconsent.initialise({
    "palette": {
      "popup": {
        "background": "#000"
      },
      "button": {
        "background": "#0000FF"
      }
    },
    "theme": "edgeless",
    "content": {
      "message": "\"Quelqu'un a dit cookies ?\" - Nous utilisons des cookies à des fins de statistiques et d'expérience utilisateur.",
      "dismiss": "Compris ! :)",
      "link": "En savoir plus...",
      "href": "/mention-legal"
    }
  });